import { HttpParams } from '@angular/common/http';
import { GetWarehousesValue } from './get-warehouses.value';

export class GetWarehousesValueDto {
    page: number;
    limit: number;

    constructor(data: GetWarehousesValue) {
        this.page = data.page;
        this.limit = data.limit;
    }

    toHttpParams(): HttpParams {
        return new HttpParams().set('page', this.page).set('limit', this.limit);
    }
}
